import { defineStore } from 'pinia'
import $utils from '@/utils'
/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useUserInfo = defineStore('userInfo', {
  state: () => ({
    userInfos: uni.getStorageSync('userInfo') || {
      name: '',
      mobile: '',
      avatar: '',
      time: '',
      roles: [],
      authBtnList: [],
    },
    patient: {},
    token: uni.getStorageSync('accessToken'),
    wxUserProfile: uni.getStorageSync('wxUserProfile') || {},
    wxSession: uni.getStorageSync('wxSession') || {},
    isLogined: !!uni.getStorageSync('accessToken'),
    userRole: uni.getStorageSync('userRole') || '',
    appCode: uni.getStorageSync('appCode') || ''
  }),
  actions: {
    async setUserInfos(userInfos) {
      // 存储用户信息到浏览器缓存
      uni.setStorageSync('userInfo', userInfos)
      this.userInfos = userInfos
      console.log(this.userInfos)
    },
    patient(patient) {
      this.patient = patient
    },
    async setToken(token) {
      // 存储用户信息到浏览器缓存
      uni.setStorageSync('accessToken', token)
      this.token = token
    },
    async setUserRoleAndAppCode(item) {
      // 存储用户角色
      uni.setStorageSync('appCode', item.appCode)
      uni.setStorageSync('userRole', item.userRole)
      this.userRole = item.userRole
    },
    async setWxUserProfile(wxUserProfile) {
      uni.setStorageSync('wxUserProfile', wxUserProfile)
      this.wxUserProfile = wxUserProfile
    },
    async setWxSession(wxSession) {
      uni.setStorageSync('wxSession', wxSession)
      this.wxSession = wxSession
    },
    async logout() {
      this.userInfos = {}
      this.token = ''
      this.doctorInfo = {}
      this.userRole = ''
      this.appCode = ''
      uni.removeStorageSync('userInfo')
      uni.removeStorageSync('accessToken')
      uni.removeStorageSync('userRole');
      uni.removeStorageSync('appCode');
    },
  },
})
